"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const KeyboardIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 18 12",
  fill: "none"
}, props), _react.default.createElement("path", {
  d: "M15.66 1.84V10.16H2.34V1.84H15.66ZM15.66 0.159999H2.34C1.87333 0.159999 1.48 0.326666 1.16 0.66C0.84 0.979999 0.68 1.37333 0.68 1.84L0.66 10.16C0.66 10.6267 0.82 11.0267 1.14 11.36C1.47333 11.68 1.87333 11.84 2.34 11.84H15.66C16.1267 11.84 16.52 11.68 16.84 11.36C17.1733 11.0267 17.34 10.6267 17.34 10.16V1.84C17.34 1.37333 17.1733 0.979999 16.84 0.66C16.52 0.326666 16.1267 0.159999 15.66 0.159999ZM8.16 2.66H9.84V4.34H8.16V2.66ZM8.16 5.16H9.84V6.84H8.16V5.16ZM5.66 2.66H7.34V4.34H5.66V2.66ZM5.66 5.16H7.34V6.84H5.66V5.16ZM3.16 5.16H4.84V6.84H3.16V5.16ZM3.16 2.66H4.84V4.34H3.16V2.66ZM5.66 7.66H12.34V9.34H5.66V7.66ZM10.66 5.16H12.34V6.84H10.66V5.16ZM10.66 2.66H12.34V4.34H10.66V2.66ZM13.16 5.16H14.84V6.84H13.16V5.16ZM13.16 2.66H14.84V4.34H13.16V2.66Z",
  fill: "currentColor"
}));

var _default = KeyboardIcon;
exports.default = _default;